import React, { Component } from 'react';
import "./../../../styles/sidebar-style.css";
import MdCloseCircle from 'react-ionicons/lib/MdCloseCircle';

class SideBarComponent extends Component {


    state = {
        current : 'Home'
    }

    navigate = (item) => {
        this.setState({
            ...this.state,
            current : item
        });
        this.closeMenu();
    }

    logout = () => {
        delete localStorage.keycloak;
        window.location.href="./"
    }

    checkActiveNode = (item) => {
        if(this.state.current == item){
            return "active"
        }else{
            return null;
        }
    }


    componentDidMount(){
       // this.openMenu();
    }

    openMenu = () => {
        document.querySelector('#sidebar').classList.add('active');
    }

    closeMenu = () => {
        document.querySelector('#sidebar').classList.remove('active');
    }

    openSubMenu = () => {
        document.querySelector('.collapse').classList.toggle('in');
    }

    render() {
        return (
            <nav id="sidebar">
                <div id="dismiss" onClick={this.closeMenu}>
                    <MdCloseCircle color="#f8f9fa" />
                </div>

                <div className="sidebar-header">
                    <h3>Voorent</h3>
                </div>

                <ul className="list-unstyled components">
                    <li onClick={(e) => {this.props.handleMenuClick('Home'); this.navigate('Home');}} className={this.checkActiveNode('Home')}>
                        <a href="#">Home</a>
                    </li>
                    <li onClick={(e) => {this.props.handleMenuClick('Orders');this.navigate('Orders');}} className={this.checkActiveNode('Orders')}>
                        <a href="#" >Orders</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Deposits'); this.navigate('Deposits');}} className={this.checkActiveNode('Deposits')}>
                        <a href="#" >Deposits</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Kyc'); this.navigate('Kyc');}} className={this.checkActiveNode('Kyc')}>
                        <a href="#" >Kyc</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Payments'); this.navigate('Payments'); }} className={this.checkActiveNode('Payments')}>
                        <a href="#" >Payments</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Invoices'); this.navigate('Invoices'); }} className={this.checkActiveNode('Invoices')}>
                        <a href="#" >Invoices</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Addresses'); this.navigate('Addresses'); }} className={this.checkActiveNode('Addresses')}>
                        <a href="#" >Addresses</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Issues'); this.navigate('Issues'); }} className={this.checkActiveNode('Issues')}>
                        <a href="#" >Issues</a>
                    </li>
                    <li onClick={(e) => { this.props.handleMenuClick('Enquiry'); this.navigate('Enquiry'); }} className={this.checkActiveNode('Enquiry')}>
                        <a href="#" >Enquiry</a>
                    </li>
                </ul>

                <ul className="list-unstyled CTAs">
                    <li>
                        <a href="#" className="btn btn-light btn-sm btn-block p-1" onClick={(e) => {this.props.handleMenuClick('Password');this.navigate('Password'); }}>Change Password</a>
                    </li>
                    <li>
                        <a onClick={this.logout} className="article cursor-pointer">Logout</a>
                    </li>
                </ul>
            </nav>
        );
    }
}

export default SideBarComponent;